<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5SiYCb/media/FC-9781035823871.jpg?1714414407095" alt="This image is the cover for the book Old Crow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Old Crow
      </h1>
      <p class="bookDescription body article font2">
        <p>Your father, an obnoxious vagabond, who left you thirty years ago for the free life of a sailor with no responsibilities, comes back into your life unannounced, saying he wants a chance to make amends and achieve reconciliation, both with you and with your younger brother who is now living in New York. But your father begins to settle in with you, and he shows no sign of leaving. A terrible truth emerges: he has returned to torment you. If he does not leave forever, you will be destroyed. What do you do?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Bovill
      </h2>
      
      <p class="authorDescription body article">James Bovill once spent six weeks in a renovation project, using a jackhammer to dig up the floors of the Vauxhall factory in Luton; on another occasion he was the MC to Archbishop Scanlan at the consecration of the Church of the Immaculate Conception in Maryhill, Glasgow. Now poised between these extremes, he works as an examiner for the IBO. Until he retired some years ago, he taught English to secondary pupils in a number of schools in the Glasgow area, where he still lives. He has three daughters, three grandchildren, and since 2009, has enjoyed the companionship of a lady from New Jersey, USA. He claims to be influenced by the work of Bob Dylan, to keep him happy, and the work of Leonard Cohen, to keep him from getting too happy. He claims his sixth novel, Old Crow, is a further search for his origins.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67ebeaee